import { render, staticRenderFns } from "./PostTab.vue?vue&type=template&id=c158f72e"
import script from "./PostTab.vue?vue&type=script&lang=js"
export * from "./PostTab.vue?vue&type=script&lang=js"
import style0 from "./PostTab.vue?vue&type=style&index=0&id=c158f72e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports